import Vue from 'vue';

export const partnerFields: {
	key: string;
	label: string;
	formatter?: (val: string) => string;
}[] = [
	{ key: 'id', label: 'Id' },
	{ key: 'name', label: 'Name' },
	{
		key: 'contributionTier',
		label: 'Contribution Tier',
		formatter: (val: string) => Vue.filter('titleCase')(val),
	},
];
